var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrefer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.58325L2.5 4.58325",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 10L2.5 10",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 10L17.5 10",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.4167L6.66667 15.4167",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.58333C13.3333 5.73392 14.2661 6.66667 15.4167 6.66667C16.5673 6.66667 17.5 5.73392 17.5 4.58333C17.5 3.43274 16.5673 2.5 15.4167 2.5C14.2661 2.5 13.3333 3.43274 13.3333 4.58333Z",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 10.0001C7.91667 11.1507 8.84942 12.0834 10 12.0834C11.1506 12.0834 12.0833 11.1507 12.0833 10.0001C12.0833 8.8495 11.1506 7.91675 10 7.91675C8.84942 7.91675 7.91667 8.8495 7.91667 10.0001Z",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.4166C2.5 16.5672 3.43275 17.4999 4.58333 17.4999C5.73392 17.4999 6.66667 16.5672 6.66667 15.4166C6.66667 14.266 5.73392 13.3333 4.58333 13.3333C3.43275 13.3333 2.5 14.266 2.5 15.4166Z",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrefer);
export default __webpack_public_path__ + "static/media/prefer.e8603c0eb3a9e9181aa649968df4b141.svg";
export { ForwardRef as ReactComponent };